export let allLabels: { [key: string]: string[] } = {
    birds:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🐦', '🐤', '🐥', '🐣', '🐔', '🐧', '🕊️', '🦃', '🐓', '🦅',
                '🦆', '🦉', '🦇'
            ],
    mammals:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🐶', '🐱', '🐭', '🐹', '🐰', '🐻', '🐼', '🐨', '🐯', '🦁',
                '🐮', '🐷', '🐵', '🐺', '🐗', '🐴', '🦄', '🐘', '🦏', '🐪',
                '🐫', '🐆', '🐅', '🐃', '🐂', '🐄', '🐀', '🐁', '🐕', '🐩',
                '🐈', '🐇', '🐿️', '🐾', '🐑', '🐐', '🦌', '🐎', '🐖'
            ],
    reptiles:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🐢', '🐍', '🦎', '🐊', '🐲', '🐉', 
            ],
    insects:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🐝', '🐛', '🐌', '🐞', '🐜', '🕷️', '🕸️', '🦂'
            ],
    sea:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🐠', '🐟', '🐡', '🐬', '🐳', '🐋', '🦈', '🐙', '🦑', '🦀',
                '🦐', '🐚'             
            ],
    bodyParts:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                // Removed: 🤟🤚🤞🤲🦴 (Unicode 9.0+, not supported on old iPads)
                '👁️', '👂', '👃', '👄', '👅', '👋', '✋', '👌', '✌️',
                '👍', '👎', '👏', '🙌', '💪', '👣', '🖐️', '✊', '👊', '🤝', '🙏'
            ],
    clothing: 
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                // Removed: 🧥🧦🥾🧣🧤 (Unicode 9.0+, not supported on old iPads)
                '👕', '👔', '👗', '👘', '👚', '👖', '👙', '👠',
                '👟', '👞', '👡', '👢', '👑', '👒', '🎩', '🎓', '⛑️',
                '💍', '👝', '👛', '👜', '🎒', '👓', '🕶️', '🌂'
            ],
    colors:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                // Removed: 🧡🖤🤍🤎 (Unicode 9.0+)
                '❤️', '💛', '💚', '💙', '💜', '💗', 
                '💖', '💞', '💝', '💔', '❣️', '💘', '💟', '💌'
            ],
    faces:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '😀', '😁', '😂', '😃', '😄', '😅', '😆', '😊', '☺️', '😉',
                '😌', '😍', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜',
                '😎', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣',
                '😖', '😫', '😩', '😢', '😭', '😤', '😠', '😡', '😳', '😱',
                '😨', '😰', '😥', '😓', '🤐', '😐', '😑', '😶', '😴', '😪'
            ],
    food:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                // Removed: 🥄 (Unicode 9.0)
                '🍕', '🍔', '🍟', '🌭', '🍿', '🎂', '🍰', '🍩', '🍪', '🍦',
                '🍧', '🍫', '🍬', '🍭', '🍮', '🍯', '🍵', '☕', '🍼', '🍴',
                '🍽️', '🍻', '🍶' 
            ],
    fruits:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🍎', '🍌', '🍇', '🍊', '🍓', '🍉', '🍑', '🍒', '🍍', '🍐',
                '🍋', '🍈', '🍏', '🍆', '🌽', '🍅', '🍄', '🌰', '🍞', '🍕',
                '🍔', '🌮', '🌯', '🍝', '🍜', '🍲', '🍱', '🍛', '🍣', '🍤'
            ],
    household:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                // Removed: 🧸🧲🧹🧺🧻🧼🧽🧴 (Unicode 11.0)
                '🏠', '🚪', '🛏️', '🛋️', '🚽', '🛁', '🚿', '🕯️', '💡', '🔦',
                '🎁', '🎈', '📺', '📱', '⏰', '⏱️', '⏲️', '🔑', '🔨', '🔧',
                '🔩', '⚙️', '🛒', '🔔', '📯', '🎀', '🎊', '🎉', '🖼️'
            ],
    music:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                // Removed: 🥁🪕 (Unicode 9.0+)
                '🎵', '🎶', '🎼', '🎹', '🎸', '🎺', '🎷', '🎻', '🎤',
                '🎧', '📻', '🔔', '🎚️', '🎛️', '🎙️', '📯'
            ],
    nature:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                // Removed: 🥀 (Unicode 9.0)
                '🌳', '🌲', '🌴', '🌱', '🌿', '🍀', '🌸', '🌺', '🌻', '🌷',
                '🌹', '🌼', '🌾', '🍂', '🍁', '🌵', '🌰', '🌽', '☘️',
                '🏵️', '💐'
            ],
    mix:
            [
                // Removed: 🦋🧩🛴 (Unicode 9.0+)
                '⚽', '🎈', '🚗', '⭐', '🌈', '🍎', '🌸', '🎵', '☀️',
                '🍕', '🎲', '📚', '🎁', '🎤', '🚀', '🐢', '🍩', '🎯',
                '🍔', '🎬', '🚴', '🌻', '🎹', '🍦', '🎨', '🚒', '🐳', '🎸', '🎭'
            ],
    space:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🌟', '⭐', '✨', '💫', '🌙', '🌛', '☀️', '🌝', '🌞',
                '🌎', '🌠', '☄️', '🚀', '🌌', '🔭', '🛰️'
            ],
    sports:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                // Removed: 🥊🥋🤸🤾 (Unicode 9.0)
                '⚽', '🏀', '🏈', '⚾', '🎾', '🏐', '🏉', '🎱', '🏓', '🏸',
                '⛳', '🎯', '🏹', '🎣', '⛸️', '🎿', '⛷️', '🏂',
                '🏊', '🏄', '🚴', '🚵', '🏇', '🏃', '⛹️', '🏋️'
            ],
    vehicles:
            [
                // Removed: 🛴🛵🛶🛸 (Unicode 9.0+)
                '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐',
                '🚚', '🚛', '🚜', '🚲', '🏍️', '✈️', '🚀', '🚁',
                '⛵', '🚤', '🛳️', '🚢', '🚂', '🚆', '🚇', '🚊', '🚝', '🚞'
            ],
    weather:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '☀️', '⛅', '☁️', '🌧️', '⛈️', '🌩️', '❄️', '⚡', '🌈', '🌪️',
                '🌫️', '💧', '💨', '☃️', '⛄', '🌤️', '🌥️', '🌦️', '🌨️', '🌬️'
            ],
    ocean:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🐠', '🐟', '🐡', '🐙', '🐚', '🐬', '🐳', '🐋', '🦀', '🐢',
                '🦑', '🐌', '🐛', '🦐', '🐊', '🦈', '🐆', '🌊', '⛵',
                '🚤', '⚓', '🏖️', '🏝️', '🗿'
            ],
    tools:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🔨', '🔧', '🔩', '⚙️', '⛏️', '✂️', '⚒️', '🛠️',
                '⛓️', '🔗', '📎', '🖇️', '📌', '📍',
                '🔬', '🔭', '📡' 
            ],
    school:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '📚', '📖', '📕', '📗', '📘', '📙', '📓', '📔', '📒', '📰',
                '✏️', '📝', '🖊️', '🖍️', '📏', '📐', '🎒', '🎓', '✂️', '📌',
                '📍', '🖇️', '📎', '📋', '📂', '📁', '🗂️', '📅' 
            ],
    buildings:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🏠', '🏡', '🏢', '🏣', '🏤', '🏥', '🏦', '🏨', '🏩', '🏪',
                '🏫', '🏬', '🏭', '🏯', '🏰', '💒', '⛪', '🕌', '🕍', '⛩️',
                '🗼', '🗽', '⛲', '⛺', '🏕️', '🗻', '🌋', '⛰️', '🏔️', '🗾'
            ],
    tech:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '💻', '🖥️', '⌨️', '🖱️', '🖨️', '📱', '☎️', '📞', '📟', '📠',
                '📡', '💾', '💿', '📀', '🎥', '📹', '📷', '📸', '🔋', '🔌',
                '💡', '🔦', '🕯️', '📻', '📺', '⏰', '⏱️', '⏲️', '⏳'
            ],
    activities:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '🎨', '🎭', '🎪', '🎬', '🎤', '🎧', '🎼', '🎹', '🎸', '🎺',
                '🎷', '🎻', '🎲', '🎯', '🎳', '🎮', '🕹️', '🎰',
                '🃏', '🀄', '🎴', '🎠', '🎡', '🎢', '🖼️'
            ],
    flags:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                // add more country flags 
                '🏁', '🚩', '🏴', '🏳️', '🏳️‍🌈', '⛳',
                '🇺🇸', '🇬🇧', '🇨🇦', '🇦🇺', '🇫🇷', '🇩🇪', '🇮🇳', '🇯🇵', '🇰🇷', '🇧🇷',
                '🇨🇳', '🇪🇸', '🇮🇹', '🇷🇺', '🇲🇽', '🇳🇱', '🇸🇪', '🇳🇿', '🇿🇦', '🇸🇬'
            ],
    time:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '⏰', '⏱️', '⏲️', '⌚', '🕐', '🕑', '🕒', '🕓', '🕔', '🕕',
                '🕖', '🕗', '🕘', '🕙', '🕚', '🕛', '🕧', '⌛', '⏳', '📅', '📆', '🗓️'
            ],
    books:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '📚', '📖', '📕', '📗', '📘', '📙', '📓', '📔', '📒', '📰',
                '🗞️', '📑', '🔖', '🏷️', '💼', '📂', '📁', '🗂️', '📋', '📊',
                '📈', '📉', '📜', '📃', '📄'
            ],
    symbols:
            [
                // Safe emojis (Unicode 6.0-8.0) - work on iOS 9+ and Android 5+
                '⭐', '🌟', '✨', '💫', '⚡', '🔥', '💧', '💨', '☁️', '🌈',
                '☀️', '🌙', '❤️', '💛', '💚', '💙', '💜', '🖤', '💔', '❣️',
                '💕', '💞', '💗', '💖', '💘', '💝', '🎵', '🎶', '🔔'
            ],
        animals: [] // Placeholder for combined animals

};

const reallyAllLabels: string[] = [];
// order is important here - flatten allLabels into reallyAllLabels
for (const category in allLabels) {
    reallyAllLabels.push("NC");
    reallyAllLabels.push(...(allLabels as { [key: string]: string[] })[category]);
    reallyAllLabels.push("END");
}

allLabels.animals = [
    ...allLabels.birds,
    ...allLabels.mammals,
    ...allLabels.reptiles,
    ...allLabels.insects,
    ...allLabels.sea
];


// reallyAllLabels.sort((a, b) => a.localeCompare(b));
console.log('reallyAllLabels:', reallyAllLabels);
export { reallyAllLabels };